module.exports = __webpack_public_path__ + "static/media/covid.1a579776.png";